import { commonPricingIntegrationErrorsManagement } from "../../utils";

/**
 * Handle errors in the extension creation and saving flow
 */
export const createSaveErrorsManagement = (error: any): string => {
    let mess = '';
    if (error.response?.status === 400) {
        switch (error.response?.data?.errorDetails) {
            case "\"ERROR_INCOMPATIBLE_BILLING_OWNER\"":
                mess = 'extensionManagement.message.error.incompatibleBillingOwner';
                break;
            case "\"ERROR_BILLING_OWNER_ID_NOT_FOUND\"":
                mess = 'extensionManagement.message.error.billingOwnerIdNotFound';
                break;
            case "\"ERROR_INCOMPATIBLE_EXTENSIONE_DATE\"":
                mess = 'extensionManagement.message.error.incompatibleExtensionDate';
                break;
            case "\"ERROR_30_DAYS_EXTENSION\"":
                mess = 'extensionManagement.message.error.30DaysExtension';
                break;
            case "\"ERROR_30_DAYS_EXTENSION_FOR_EXTENDED_RA\"":
                mess = 'extensionManagement.message.error.30DaysExtension4extendedRa';
                break;
            case "\"ERROR_EXTENSION_INCOMPATIBLE_STATE\"":
                mess = "extensionManagement.message.error.errorExtensionInconsistentRaState"
                break;
            case "\"ERROR_EXTENSION_NOT_COMPATIBLE_FOR_SUBSCRIPTION\"":
                mess = "extensionManagement.message.error.extensionNotCompatibleForSubscription"
                break;
            case "\"COMPANY_EXTENSION_NOT_PERMITTED\"":
                mess = 'extensionManagement.message.error.companyExtensionNotPermitted';
                break;
            case "\"ERROR_30_DAYS_EXTENSION_NOT_B2B\"":
                mess = 'extensionManagement.message.error.error30DaysExtensionNotB2B';
                break;
            case "\"ERROR_360_DAYS_EXTENSION\"":
                mess = 'extensionManagement.message.error.error360DaysExtension';
                break;
            case "\"ERROR_UNPERMITTED_EARLY_PICKUP\"":
                mess = 'extensionManagement.message.error.errorUnpermittedEarlyPickup';
                break;
            case "\"ERROR_UNPERMITTED_LATE_PICKUP\"":
                mess = 'extensionManagement.message.error.errorUnpermittedLatePickup';
                break;
            case "\"ERROR_PRC_RESPONSE_NOT_EXPECTED\"":
                mess = 'extensionManagement.message.error.errorPrcResponseNotExpected';
                break;
            case "\"ERROR_30_DAYS_EXTENSION_BY_DRIVER\"":
                mess = 'extensionManagement.message.error.30DaysExtensionByDriver';
                break;
            case "\"ERROR_PRICING_MISSING_CONFIGURATION\"":
                mess = 'extensionManagement.message.error.errorPricingMissingConfiguration';
                break;
            case "\"SUBSCRIPTION_DROP_OFF_TOO_LATE\"":
                mess = 'extensionManagement.message.error.subscriptionDropOffTooLate';
                break;
            case "\"SUBSCRIPTION_INSUFFICIENT_DAYS\"":
                mess = 'extensionManagement.message.error.subscriptionInsufficientDays';
                break;
            case "\"ERROR_CALLING_SUBSCRIPTION_RA_EXTENSION_CHECK\"":
                mess = 'extensionManagement.message.error.subscriptionRaExtensionCheck';
                break;
            case "\"ERROR_EXTENSION_HAS_PENDING_RA\"":
                mess ='extensionManagement.message.error.alredyHasFutureRenewals';
                break;
        }
    } else if (error.response?.status === 404) {
        if (error.response?.data?.errorDetails === "\"ERROR_ID_RA_NOT_FOUND\"") {
            mess = 'extensionManagement.message.error.idRaNotFound';
        }
    }

    if(!mess) 
        mess = commonPricingIntegrationErrorsManagement(error) || 'translation:error.tryLater';
    
    return mess;
};